//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import couponLine from '@/components/coupon/index.vue'
import moment from 'dayjs'
import uParse from '@/components/gaoyia-parse/parse.vue'
import uniNumberBox from "@/components/uni-number-box/uni-number-box.vue"
import uniPopup from "@/components/uni-popup/uni-popup.vue"
import paymentSelect from '@/components/paymentSelect/index.vue'
export default {
    data(){
        return{
            popupShow:false,
            bodyId: '', //主体id
            inDate: '', //入住日期
            outDate: '', //离店日期
            id: '', //产品id
            total:'', //入住总天数
            detail: {},  //产品详情
            countPrice: 0,  //优惠券价格
            couponCode: '', //优惠券id
            forms: { //用户信息
                cellPhone:'',
                customerName:'',
                idCard:'',
                quantity: 1,
                checkInTime: '',
                checkOutTime: '',
                stayDays: '',
                memberId: '',
                hotelId: '',
                roomId: '',
                discountPrice: ''
            },
            config: {
                price: 359,
                phone: '',
                IDNumber: '',
            },
            memberId: '',
            orderId: '',
            showPaymentSelect: false,
            submitLoading: false,
            //用户信息判断
            isNameError: false, 
            isPhoneError: false,
            isIDError: false
        }
    },
    components:{couponLine,uParse,uniNumberBox,uniPopup,paymentSelect},
    computed: {
        squares () {
            return this.detail.square ? '/' + this.detail.square + 'm²' : ''
        },
        leftStock () {
            if (this.detail.minStock) {
                return this.detail.minStock - this.forms.quantity
            } else {
                return 0
            }
        },
        checkIn () {
            return this.inDate.substr(0, 10)
        },
        checkOut () {
            return this.outDate.substr(0, 10)
        },
        num () {
            return this.total + '晚'
        },
        phone () {
            return (this.config.phone.substr(0, 4) +'***' +this.config.phone.substr(this.config.phone.length - 4, 4))
        },
        IDNumber () {
            return (this.config.IDNumber.substr(0, 4) +'***'+this.config.IDNumber.substr(this.config.IDNumber.length - 4, 4))
        },
        pricesTitle () {
            return this.pricesList.length > 1 ? '房间均价' : '房间单价'
        },
        pricesList () {
            return this.detail.list ? this.detail.list : []
        },
        totalPrice () {
            return this.detail.sumPrice? this.forms.quantity * this.detail.sumPrice:0
        },
        price () {
            let price = this.countPrice>0?parseFloat(this.totalPrice - this.countPrice).toFixed(2):parseFloat(this.totalPrice).toFixed(2)
            return price <= 0 ? 0.01 : price
        },
        averagePrice () {
            console.log(this.detail.sumPrice)
            console.log(this.pricesList.length)
            let averagePrice = parseFloat(this.detail.sumPrice / this.pricesList.length).toFixed(2)
            return averagePrice
        }
    },
    onLoad(event){
        this.bodyId = event.bodyId
        this.checkInTime = this.inDate = event.inDate
        this.checkOutTime = this.outDate = event.outDate
        this.id = event.productId
        this.stayDays = this.total = event.total
        this.getOrderDetail()
    },
	onShow(){
		// this.$isLogin()
		this.memberId=this.$store.state.userInfo.memberId		
		if(this.memberId){
			this.queryUserinfo()
			this.getCoupon()
		}
	},
    methods:{
        testName () {
            return !!this.forms.customerName && /^[\u4E00-\u9FA5A-Za-z]+$/.test(this.forms.customerName)
        },
        testPhone () {
            return /^1[345789]\d{9}$/.test(this.forms.cellPhone)
        },
        testID () {
            return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.forms.idCard)
        },
        format (date, mould) {
            return moment(date).format(mould)
        },
        customerName(e){
			this.forms.customerName=e.target.value
		},
		cellPhone(e){
			this.forms.cellPhone=e.target.value
        },
        idCard(e){
			this.forms.idCard=e.target.value
        },
        // 选择优惠券的回调函数,count是折扣金额，id是优惠券id
        changePrice (msg) {
            this.countPrice = msg.couponDenomination
            this.couponCode = msg.childCouponCode
        },
        //库存数量
        changeNumber(val){
            this.forms.quantity = val
        },
        //用户信息获取
        queryUserinfo () {
            let _this = this
            if (this.$store.state.userInfo.memberId) {
                this.$ajax({
                    method: 'post',
                    url: '/weChat/member/queryById',
                    data: {
                        memberId: this.memberId
                    }
                }).then(res=>{
                    _this.forms.cellPhone = res.data.phone
                    _this.forms.customerName = res.data.memberName
                    _this.forms.idCard = res.data.idCard 
                })
            }
        },
        //房型详情
        getOrderDetail () {
            let _this =this
            this.$ajax({
                method: 'post',
                url: '/weChat/hotelProduct/queryById',
                isForms: true,
                data: {
                    beginTime: _this.inDate,
                    endTime: _this.outDate,
                    productId: _this.id
                }
            }).then(res=>{
                _this.detail = res.data
                _this.productTypeCode = res.data.productTypeCode
                if (_this.detail.minStock < 1) {
                    uni.redirectTo({
                        url:`/hotel/detail?id=${_this.id}`
                    })
                } 
            })
        },
        onSubmit () {
            let _this = this
            this.isNameError = !this.testName()
            this.isPhoneError = !this.testPhone()
            this.isIDError = !this.testID()
            if (!this.submitLoading) {
                if (!this.isNameError && !this.isPhoneError && !this.isIDError) {
					let obj = {
					  productTypeCode: this.productTypeCode,
					  productId: this.id,
					  memberId: this.memberId,
					  totalQuantity: this.forms.quantity,
					  orderName: this.forms.customerName,
					  orderPhone: this.forms.cellPhone,
					  idCard: this.forms.idCard,
					  checkInTime: this.inDate,
					  checkOutTime: this.outDate,
					  couponCode: this.couponCode||''
					}
                    this.submitLoading = true
                    this.$ajax({
                        method: 'post',
                        url: '/weChat/hotelOrder/add',
                        isForms: true,
                        data: obj
                    }).then(res=>{
						if(res.success) {
                           _this.orderId = res.data
                            _this.showPaymentSelect=true
                            _this.submitLoading = false 
                        }
                        
                    }).catch(err=>{
                        console.log('fail')
                        _this.submitLoading = false
                    })
                }
            }
        },
        handelClose () {
            this.showPaymentSelect = false
            this.submitLoading = false
        }
    }
}
